const actionTypes = require('constants/actionTypes');

function setVisibleStep(data) {
    return {
        type: actionTypes.APPLYFOR_SET_VISIBLE_STEP,
        payload: {
            data
        }
    };
}

function setStepValid(data) {
    return {
        type: actionTypes.APPLYFOR_SET_STEP_VALID,
        payload: {
            data
        }
    };
}

module.exports = {
    setVisibleStep,
    setStepValid
}
